import KnAnnouncementCard from '../../components/KnAnnouncementCard/KnAnnouncementCard.vue';
import KnCardGraph from '../../components/KnCardGraph/KnCardGraph.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { /*getItem,*/ postItem } from '../../../../api/api-methods';
import { numberFormatMX } from '../../../shared/helpers/dataUtils';
import {
  getFirstDayOfMonth,
  getLastDayOfMonth,
  formatStringDateToLocaleDate,
} from '../../../shared/helpers/dateUtils';
import { mapActions } from 'vuex/dist/vuex.common.js';
import { fetchAnnouncements } from '../../../employees/helpers/announcementOptions';
import {
  fetchGroups,
  fetchStudents,
} from '../../../employees/helpers/reportCardOptions';
// import { paginationMixin } from '../../../shared/mixins/paginationMixin';
export default {
  name: 'TutorDashboardIndex',
  components: { KnAnnouncementCard, KnCardGraph },
  mixins: [],
  props: {},
  data() {
    return {
      studentsPerTutor: 0,
      groups: [],
      students: [],
      announcements: [],
      studentIds: [],
      groupIds: [],
      announcementLoading: false,
      currentDebt: 0,
      overdueDebt: 0,
      currentDebtNumber: 0,
      overdueDebtNumber: 0,
      dateRange: {
        from: '',
        to: '',
      },
    };
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    ...mapGetters(['nameUserLoggedIn', 'isTutor']),
    getTutorId() {
      return this.isTutor ? this.userData.perfiles[2].tutor[0].id : null;
    },
  },
  async created() {
    this.setIsLogin(false);
    this.announcementLoading = true;
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    this.dateRange.from = getFirstDayOfMonth(currentYear, currentMonth);
    this.dateRange.to = formatStringDateToLocaleDate({ date: today }); // getLastDayOfMonth(currentYear, currentMonth);
    const lastDayPrevMonth = getLastDayOfMonth(currentYear, currentMonth - 1);
    await this.getStudentsPerTutor();
    await this.getTotalOverdueDebt(lastDayPrevMonth);
    await this.getTotalCurrentDebt();
    await this.getStudents();
    await this.getGroups();
    await this.getAnnouncements();
    this.setIfTutorHasDebts({
      overdueMount: this.overdueDebtNumber,
      currentMount: this.currentDebtNumber,
    });
    this.announcementLoading = false;
  },
  methods: {
    ...mapMutations(['setIsLogin']),
    ...mapActions(['setIfTutorHasDebts']),
    async getStudentsPerTutor() {
      try {
        const response = await postItem(
          '/app-personas/helpers/numero-total-hijos-tutorados',
          {
            id_tutor: this.getTutorId,
          }
        );
        if (response && response.numero_hijos_tutorados) {
          this.studentsPerTutor = response.numero_hijos_tutorados;
        }
      } catch (error) {
        console.error('Error al obtener alumnos por tutor. ', error);
      }
    },
    async getTotalCurrentDebt() {
      try {
        const response = await postItem(
          '/app-administracion/helpers/get-adeudo-actual-tutor',
          {
            id_tutor: this.getTutorId,
          }
        );
        if (response) {
          this.currentDebt = numberFormatMX.format(response);
          this.currentDebtNumber = response;
        }
      } catch (error) {
        console.error('Error al obtener alumnos por tutor. ', error);
      }
    },
    async getTotalOverdueDebt(lastDayMonth) {
      try {
        const response = await postItem(
          '/app-administracion/helpers/get-adeudos-vencidos-tutor',
          {
            id_tutor: this.getTutorId,
            fecha: lastDayMonth,
          }
        );
        if (response) {
          this.overdueDebt = numberFormatMX.format(response);
          this.overdueDebtNumber = response;
        }
      } catch (error) {
        console.error('Error al obtener alumnos por tutor. ', error);
      }
    },
    async getStudents() {
      const { ok, data } = await fetchStudents({
        institutionId: this.institutionId,
        tutorId: this.getTutorId,
        systemStatus: true,
      });
      this.students = ok ? data : [];
      this.studentIds = this.students.map((s) => s.id);
    },
    async getGroups() {
      const groupSet = new Set();
      let studentsGroups = [];
      if (this.studentIds.length) {
        for (const sId of this.studentIds) {
          const { ok, data } = await fetchGroups({
            institutionId: this.institutionId,
            studentId: sId,
            systemStatus: true,
          });
          studentsGroups = ok ? data : [];
          studentsGroups.map((sg) => groupSet.add(sg.id));
        }
        this.groupIds = [...groupSet];
      }
    },
    async getAnnouncements() {
      const today = new Date().toLocaleDateString('sv-SE');
      const announcementsSet = new Set();
      let generalAnnouncements = [];
      let groupAnnouncements = [];
      const { ok: okGroup, data: dataGroup } = await fetchAnnouncements({
        institutionId: this.institutionId,
        groupId: this.groupIds.length ? this.groupIds.join(',') : null,
        systemStatus: true,
        todayDate: today,
        limit: 20,
      });
      groupAnnouncements = okGroup ? dataGroup : [];
      groupAnnouncements.map((gA) => announcementsSet.add(gA.id));

      const { ok: okGeneral, data: dataGeneral } = await fetchAnnouncements({
        institutionId: this.institutionId,
        isGeneral: true,
        systemStatus: true,
        todayDate: today,
        limit: 20,
      });
      generalAnnouncements = okGeneral ? dataGeneral : [];
      generalAnnouncements.map((gA) => announcementsSet.add(gA.id));

      const allAnnouncements = [...groupAnnouncements, ...generalAnnouncements];
      // console.log('announcementSet', announcementsSet);
      const announcementsIds = [...announcementsSet];
      announcementsIds.forEach((aId) => {
        const findedAnnouncement = allAnnouncements.find((a) => a.id === aId);
        if (findedAnnouncement) {
          this.announcements.push(findedAnnouncement);
        }
      });
      // console.log('Anuncios obtenidos no repetidos', this.announcements);
    },
  },
};
